<template>
  <div>
    <a-modal v-model="showModal" title="About" :centered="true" :dialog-style="{ margin: '0px', width: '100px !important' }" @ok="() => (showModal = false)">
      <template slot="footer">
        <button key="cancel" @click="showModal = false" :style="{ background: '#e2e8f0', padding: '12px 24px', 'border-radius': '6px', 'font-weight': 700, color: '#47556e', border: 'none' }">
          Cancel
        </button>
        <a-button
          key="submit"
          type="primary"
          @click="save()"
          class="primary-button"
          :style="{ border: '1px solid ' + getPrimaryColor(), background: getPrimaryColor(), padding: '12px 24px', 'border-radius': '6px', 'font-weight': 700 }"
        >
          Save
        </a-button>
      </template>

      <div class="row my-3">
        <div class="col-md-6 col-sm-12 text-left">
          <label for="gender" class="mb-2 font-weight-bold input-label">Gender</label>
          <div class="">
            <a-select :size="'large'" class="w-100 newPostSelect" defaultValue="male" style="width: 120px" v-model="basicData.gender">
              <a-select-option value="male">Male</a-select-option>
              <a-select-option value="female">Female</a-select-option>
              <a-select-option value="other">Other</a-select-option>
            </a-select>
            <div class="error-container" v-if="$v.basicData.gender.$error">
              <div class="error-item" v-if="!$v.basicData.gender.required">Gender is required</div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-12 mb-sm-2">
          <label for="borthday" class="mb-2 font-weight-bold input-label">Birth Date</label>
          <!-- <a-month-picker class="d-inline-block pr-0 w-100" :size="'large'" placeholder="Year and Month only" :defaultValue="basicData.dob" @change="handleBirthDateChange" /> -->
          <DatePicker
            v-model="basicData.dob"
            :disabled-date="tempValue => tempValue > maxBirthdayDate"
            placeholder="Year and Month only"
            type="month"
            class="w-100 new-datepicker"
            :append-to-body="false"
            :clearable="false"
          />
          <div class="error-container" v-if="$v.basicData.dob.$error">
            <div class="error-item" v-if="!$v.basicData.dob.required">DOB is required</div>
          </div>
        </div>
      </div>
      <div class="row my-3">
        <div class="col-md-6 col-sm-12 text-left">
          <label for="ibsType" class="mb-2 font-weight-bold input-label">
            My Type of
            {{
              currentCircle.condition_type
                .replace("My", "")
                .replace("Circle", "")
                .replace("my", "")
                .replace("circle", "")
                .trim()
            }}
          </label>
          <div>
            <a-select
              :defaultValue="null"
              :size="'large'"
              class="w-100 newPostSelect"
              style="width: 120px"
              @change="handleDiseaseType"
              v-model="basicData.disease_type"
              :disabled="!circleDiseaseTypes.length"
            >
              <a-select-option :value="disease.display_name" v-for="disease in circleDiseaseTypes" :key="disease.id">{{ disease.display_name }}</a-select-option>
            </a-select>
            <div class="error-container" v-if="$v.basicData.disease_type.$error">
              <div class="error-item" v-if="!$v.basicData.disease_type.required">Required</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 mb-sm-2">
          <label for="diagnosis" class="mb-2 font-weight-bold input-label">My date of diagnosis</label>
          <!-- <a-month-picker
            class="d-inline-block pr-0 w-100"
            :size="'large'"
            placeholder="Year and Month only"
            :defaultValue="basicData.diagnosis_date ? (basicData.diagnosis_date._d != null ? basicData.diagnosis_date : null) : null"
            @change="handleDiagnosisDateChange"
          /> -->
          <DatePicker
            v-model="basicData.diagnosis_date"
            :disabled-date="tempValue => tempValue >= new Date()"
            placeholder="Year and Month only"
            type="month"
            class="w-100 new-datepicker"
            :append-to-body="false"
            :clearable="true"
          />
          <div class="error-container" v-if="$v.basicData.diagnosis_date.$error">
            <div class="error-item" v-if="!$v.basicData.diagnosis_date.required">Date of Diagnosis is required</div>
          </div>
        </div>
      </div>
      <div class="row my-3">
        <div class="col-md-6 col-sm-12 text-left">
          <label for="relationship" class="mb-2 font-weight-bold input-label">Relationship Status</label>
          <div class="">
            <a-select :size="'large'" class="w-100 newPostSelect" defaultValue="married" style="width: 120px" v-model="basicData.relationship_status">
              <a-select-option :value="relationshipStatusValue.key_name" v-for="relationshipStatusValue in relationshipStatusValues" :key="relationshipStatusValue.id"
                >{{ relationshipStatusValue.display_name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 text-left mb-sm-2">
          <label for="situation" class="mb-2 font-weight-bold input-label">Current Situation</label>
          <div class="">
            <a-select :size="'large'" class="w-100 newPostSelect" defaultValue="I am working fulltime" style="width: 120px" v-model="basicData.current_situation">
              <a-select-option :value="currentSituationValue.key_name" v-for="currentSituationValue in currentSituationValues" :key="currentSituationValue.id"
                >{{ currentSituationValue.display_name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>
      <div class="row my-3">
        <div class="col-md-6 col-sm-12 text-left">
          <label for="gender" class="mb-2 font-weight-bold input-label">Interests</label>

          <div class="">
            <a-select
              mode="multiple"
              :value="basicData.activity"
              placeholder="Select"
              class="w-100 custom-input interestsSelect"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              notFoundContent=""
              @search="handleActivity"
              @change="handleActivityChange"
            >
              <a-select-option v-for="(i, index) in activities" :key="index" :value="i.display_name">
                {{ i.display_name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>
      <div class="row my-3">
        <div class="col-12 text-left">
          <label for="mini_bio" class="mb-2 font-weight-bold input-label">Mini Bio</label>
          <a-textarea placeholder="Tell us about yourself" :rows="8" v-model="basicData.mini_bio" :maxlength="max" />
          <p class="text-right">
            <small class="font-light">{{ max - (basicData.mini_bio ? basicData.mini_bio.length : 0) }} Characters remaining</small>
          </p>
        </div>
      </div>
      <div v-if="loadingScreen" class="spinnerContainer-post">
        <a-spin size="large" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import { mapGetters } from "vuex"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import DatePicker from "vue2-datepicker"

const AppRepository = RepositoryFactory.get("app")

export default {
  name: "EditBasicDetails",
  components: { DatePicker },
  data() {
    return {
      loadingScreen: false,
      showModal: false,
      key: null,
      max: 2000,
      basicData: {
        gender: null,
        dob: null,
        disease_type: "",
        diagnosis_date: null,
        relationship_status: null,
        mini_bio: null,
        current_situation: null,
        activity: undefined,
      },
      activities: undefined,
      fetchUser: null,
      relationShipSorted: [],
      maxBirthdayDate: null,
    }
  },

  validations: {
    basicData: {
      gender: {
        // required,
      },
      dob: {
        required,
      },
      diagnosis_date: {
        // required
      },
      disease_type: {
        // required
      },
      activity: {
        // required
      },
    },
  },

  computed: {
    ...mapGetters({
      relationshipStatusValues: "User/relationshipStatusValues",
      currentSituationValues: "User/currentSituationValues",
      circleDiseaseTypes: "Circle/circleDiseaseTypes",
    }),
  },

  methods: {
    disabledDiagnosisDates(curr) {
      return curr >= new Date() || curr <= new Date(this.basicData.dob || "")
    },

    handleDiseaseType(value) {
      this.basicData.disease_type = value
    },

    show(data, fetchData) {
      //
      this.showModal = true
      // this.basicData = data
      this.handleActivity("a")
      this.basicData.gender = data.gender
      this.basicData.dob = new Date(data.dob)
      // this.basicData.dob = this.moment(data.dob)
      this.basicData.disease_type = data.disease_type
      this.basicData.diagnosis_date = data.diagnosis_date ? new Date(data.diagnosis_date) : null
      // this.basicData.diagnosis_date = this.moment(data.diagnosis_date)
      // this.basicData.diagnosis_date = this.basicData.diagnosis_date._d != "Invalid Date" ? this.basicData.diagnosis_date : null
      this.basicData.relationship_status = data.relationship_status
      this.basicData.mini_bio = data.mini_bio
      this.basicData.current_situation = data.current_situation
      this.basicData.activity = data.interests
      this.fetchUser = fetchData
      this.maxBirthdayDate = this.moment().subtract(18, "years")
      console.log("this.basicData:", this.basicData)
    },
    hide() {
      this.showModal = false
    },
    handleBirthDateChange(date, dateString) {
      this.basicData.dob = dateString + "-01"
      this.$v.basicData.dob.$touch()
    },
    handleDiagnosisDateChange(date, dateString) {
      this.basicData.diagnosis_date = dateString + "-01"
      this.$v.basicData.diagnosis_date.$touch()
    },
    handleActivity(search) {
      AppRepository.getInterests(search)
        .then(res => {
          this.activities = res.data.data.data ? res.data.data.data : []
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleActivityChange(val) {
      this.basicData.activity = val
      this.activities = []
    },
    save() {
      this.loadingScreen = true
      this.$v.basicData.$touch()
      const user = this.authUser
      const key = user.user.role === "patient" ? "normal_user" : "caregiver"
      const payload = {
        gender: this.basicData.gender,
        dob: this.moment(this.basicData.dob).format("YYYY-MM-DD"),
        relationship_status: this.basicData.relationship_status,
        current_situation: this.basicData.current_situation,
        [key]: {
          mini_bio: this.basicData.mini_bio,
          interests: this.basicData.activity,
          diagnosis_date: this.basicData.diagnosis_date != null ? this.moment(this.basicData.diagnosis_date).format("YYYY-MM-DD") : null,
          disease_type: this.basicData.disease_type,
        },
      }
      console.log({ payload })
      if (!this.$v.basicData.$anyDirty === false && this.$v.basicData.$anyError === false) {
        const headers = { Authorization: `Bearer ${user.user.token}` }
        this.$http
          .put(`${process.env.BASE_API_URL}/${user.user.role === "patient" ? "normaluserabout" : "caregiverabout"}/?user_id=${user.user.id}&circle_id=${this.currentCircle.id}`, payload, { headers })
          .then(res => {
            this.fetchUser()
            this.$store.commit("Posts/setPercent", true)
            this.hide()
            this.loadingScreen = false
          })
          .catch(err => {
            this.loadingScreen = false
          })
      } else {
        this.loadingScreen = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.text-left {
  @media screen and (max-width: 900px) {
    margin-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/profile/BasicDetails.vue